import { render, staticRenderFns } from "./CallModal.vue?vue&type=template&id=01a94f70&scoped=true&"
import script from "./CallModal.vue?vue&type=script&lang=js&"
export * from "./CallModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a94f70",
  null
  
)

export default component.exports